import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import './index.styl'
require('./styles.css')

const CLOSE_TIMEOUT = 500

export default function ReactSlidingPane ({
  isOpen,
  title,
  subtitle,
  onRequestClose,
  onAfterOpen,
  children,
  className,
  overlayClassName,
  from = 'right',
  width
}) {
  const directionClass = `slide-pane_from_${from}`
  return <Modal
    className={`slide-pane ${directionClass} ${className || ''}`}
    style={{content: {width: width || '90%'}}}
    overlayClassName={`slide-pane__overlay ${overlayClassName || ''}`}
    closeTimeoutMS={CLOSE_TIMEOUT}
    isOpen={isOpen}
    onAfterOpen={onAfterOpen}
    onRequestClose={onRequestClose}
    contentLabel={`Modal "${title || ''}"`}>
    <div className='slide-pane__header' onClick={onRequestClose}>
      <div className='slide-pane__title-wrapper'>
        <h3 className='slide-pane__title'>{title}</h3>
      </div>
      <div className='slide-pane__close'><div className='closer-text'>Fermer</div><i className='chevron right icon' /></div>
    </div>
    <div className='slide-pane__content' onClick={onRequestClose}>
      {children}
    </div>
  </Modal>
}

ReactSlidingPane.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.any,
  subtitle: PropTypes.any,
  onRequestClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  from: PropTypes.oneOf(['left', 'right']),
  width: PropTypes.string
}
